module.exports = new __parcel__URL__("beetlejuice-catherine-ohara.601227c5.gif").toString();